const { createStatusMachine } = require('./statusMachine');

const MealStatus = Object.freeze({
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
});

const mealStatusMachine = createStatusMachine({
  entityName: 'meal',
  states: Object.values(MealStatus),
  initial: MealStatus.ACTIVE,
  transitions: {
    [MealStatus.ACTIVE]: [MealStatus.CANCELLED],
    [MealStatus.CANCELLED]: [],
  },
});

module.exports = { MealStatus, mealStatusMachine };
